export const iconFontAwesomeEnergyWater = (
	<i className="fa-solid fa-water"></i>
);
